<template>
    <div class="velkommen topspacing">

        <div class="loading-overlay" v-if="showLoader">
			<div class="counter">
                <div v-if="errorMessage.length == 0">
                    <h3>Installerer MålerTjek app'en <span class="loading-overview"><span>.</span><span>.</span><span>.</span></span></h3>
                    <p>Trin {{activeStep}} af {{totalSteps}}</p>
				</div>
                <div v-if="errorMessage.length > 0">
                    {{errorMessage}}
                    <a class="button error-button" @click="closeError">Okay</a>
                </div>
			</div>
		</div>

        <div class="header" style="height: 55.4px;">
            <h1>Hent indstillinger</h1>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="large-12 cell">
                <section>
                    <div class="header-welcome">
                        <img src="./../assets/image/logo.png" alt="logo">
                    </div>
                    <div class="content text-center">
                        <p>
                            NIRAS har udviklet et system, der rationaliserer arbejdsopgaver vedrørende kontrol og udskiftning af forbrugsmålere i forsyningssektoren. Programmet hedder MålerTjek, og med det fjerner du tidsrøvere og gør samtidig livet lettere for både forsyningernes montører og deres administration samt for borgerne. 
                        </p>
                        <div class="text-center download-container">
                            <a class="button call-to-action" @click="getServerData"><i class="material-icons">file_download</i>Hent app</a>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>

import DAL, {mongoObjectId} from './../js/Sync/dal';
import clearQueue from './../js/Sync/clearQueue';
import zango from 'zangodb';

export default {
    name: 'velkommen',
    data() {
        return {
            showLoader: false,
            activeStep: 0,
            totalSteps: 2,
            errorMessage: ''
        }
    },
    methods: {
        getServerData() {
            var _this = this;
            var promiseArray = [];
            this.showLoader = true;
            const promises = [Promise.resolve(), Promise.resolve()]

            clearQueue(promises)
                .then(function () {
                _this.activeStep = 1;

                return new Promise((resolve, reject) => {
                    _this.$http.get('https://mobileservice.maalertjek.niras.dk/api/indstillinger')
                    .then(response => resolve(response))
                    .catch(() => reject)
                })
                .then(response => {
                    console.log("response", response.body);
                    return response.body;
                }, response => {
                    console.log("error");
                    this.errorMessage = "Der opstod en fejl under installationen";
                    return false;
                })
            })
            .then(function (data) {
                if (data == undefined) {
                    console.log("response is undefined");
                    this.errorMessage = "Der opstod en fejl under installationen";
                } else {
                    console.log("inserting into IndexedDB", data);
                    return DAL.setItem("MTSettings", "settings", data);
                }
            })
            .then(function () {
                _this.activeStep = 2;

                return new Promise((resolve, reject) => {
                    _this.$http.get('https://mobileservice.maalertjek.niras.dk/api/v1/lister/allelister')
                    .then(response => resolve(response))
                    .catch(() => reject)
                })
                .then(response => {
                    console.log("response", response.body);
                    return response.body;
                }, response => {
                    console.log("error");
                    this.errorMessage = "Der opstod en fejl under installationen";
                    return false;
                })
            })
            .then(function (data) {
                if (data == undefined) {
                    console.log("response is undefined");
                    this.errorMessage = "Der opstod en fejl under installationen";
                } else {
                    console.log("inserting into IndexedDB", data.bookinger);
                    var promiseArray = [];

                    data.bookinger.forEach(function (booking) {
                        promiseArray.push(function () {
                            return DAL.setItem("MTTasks", booking.id, booking).then(function () {
                                console.log("Inserted task:", booking.id)
                            });
                        })
                    });
                    return clearQueue(promiseArray);
                }
            })
            .then(function () {
                _this.showLoader = false;
                _this.$cookie.set('downloaded', true, {expires: '1y'})
                _this.$router.push({
                    name: 'projekter'
                });
            });
        }
    },
    mounted() {
        $(document).foundation();
        $('header').hide();

        if (this.$cookie.get('downloaded')) {
            this.$router.push({
                name: 'projekter'
            });
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// velkommen.vue?187c39ed